import firebase from 'firebase/app'
import 'firebase/auth'

import { FB_CONFIG } from './config'

let fireauth

const initFirebase = () => {
    firebase.initializeApp(FB_CONFIG)
    fireauth = firebase.auth()
}

const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: '/',
    signInOptions: [
        {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            customParameters: {
            }
        }
    ]
}

const actionCodeSettings = {
    url: 'http://localhost:3000/password-reset/',
    handleCodeInApp: true
}

export {
    initFirebase,
    fireauth,
    uiConfig,
    actionCodeSettings
}
